import * as React from 'react';
import { ButtonType, CustomButton } from "soprasteria-ui-library";
import { ITreatmentReportTreatment } from '../../../models/ITreatmentReport';
import { TreatmentsModal } from './TreatmentsModal';
import { TreatmentsTable } from './TreatmentsTable';

interface ITreatments {
    patientId: number;
    registeredTreatments: ITreatmentReportTreatment[];
    onSubmit: (treatment: ITreatmentReportTreatment, onCallEnd?: () => void) => void;
    onDelete: (treatmentId: number) => void;
    isEditable?: boolean;
}

export const Treatments: React.FunctionComponent<ITreatments> = ({ patientId, registeredTreatments, onSubmit, onDelete, isEditable }) => {
    const [renderModal, setRenderModal] = React.useState<boolean>(false);
    
    const closeModal = () => {
        setRenderModal(false);
    }

    return (
        <section >
            <div className="row panel">
                <h5 className="col-6">Åtgärdskoder</h5>
                <div className="col-6 text text-right">
                    {
                        isEditable ?
                            <CustomButton buttonText="Lägg till åtgärdskod" buttonType={ButtonType.create} onClick={() => setRenderModal(true)} />
                            : null
                    }
                </div>
            </div>
            <TreatmentsTable registeredTreatments={registeredTreatments} onDelete={isEditable ? onDelete : undefined} />
            {
                renderModal ?
                    <TreatmentsModal patientId={patientId} onSubmit={onSubmit} closeModal={closeModal} />
                    : null
            }
        </section>
    )
}